import * as THREE from 'three';
import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js';

const MotionBlurShader = {
  uniforms: {
    tDiffuse: { value: null as THREE.Texture | null },
    uBlurStrength: { value: 0.0 },
    uCenter: { value: new THREE.Vector2(0.5, 0.5) },
  },
  vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform sampler2D tDiffuse;
    uniform float uBlurStrength;
    uniform vec2 uCenter;
    varying vec2 vUv;
    void main() {
      vec2 dir = (vUv - uCenter) * uBlurStrength * 0.035;
      vec4 col = vec4(0.0);
      for (int i = 0; i < 6; i++) {
        col += texture2D(tDiffuse, vUv - dir * float(i));
      }
      gl_FragColor = col / 6.0;
    }
  `,
};

export class FpsMotionBlurPass {
  public readonly pass: ShaderPass;

  constructor() {
    this.pass = new ShaderPass(MotionBlurShader);
  }

  setBlurStrength(v: number): void {
    this.pass.uniforms['uBlurStrength'].value = Math.max(0, Math.min(1, v));
  }
}
